import React from 'react';
import PenIcon from '../Icons/solid/PenIcon';
import { COLORS } from '../../config';
import SecondaryButton from '../Buttons/SecondaryButton';
import ClosedLockIcon from '../Icons/solid/ClosedLockIcon';
import DownloadIcon from '../Icons/solid/DownloadIcon';

function FieldWithEdit({
  edit,
  data,
  override,
  onChange,
  label,
  children,
  button,
  buttonText,
  buttonOnClick,
  locked,
  min,
  max,
  onKeyPress,
  showEditIcon=true,
  required=false,
  placeholder,
  icon,
  type,
  ...other
}) {
  return (
    <div className='flex border-b-2 border-gray-100 pb-2 w-full'>
      <span className="uppercase font-bold text-secondary w-36">{label}</span>
      {!override &&
      <>
        {!edit &&
        <div className='flex-grow pl-12 p-1 break-normal whitespace-normal overflow-x-scroll'>
          <p className="text-gray-600 ">{ data ? data : ' ' }</p>
        </div>
        }
        {edit && !button &&
        <div className='flex justify-between flex-grow pl-12 p-1 overflow-x-scroll'>
          {!locked && 
          <>
            <input
              type={type ? type : 'text'} 
              className="w-full md:w-72" 
              placeholder={ placeholder } 
              value={data}
              onChange={onChange}
              minLength={min || null}
              maxLength={max || null}
              onKeyPress={onKeyPress}
              required={required}
              {...other}
            />
             {showEditIcon && (<PenIcon fill={COLORS.colorSecondary} className='mr-3'/>)}
          </>
          }
          {locked &&  
          <>
            <span className="text-gray-600">{ data }</span>
            <ClosedLockIcon fill={COLORS.colorSecondary} className='mr-3'/>
          </>
          }
        </div>
        }
        {edit && button &&
        <div className='flex justify-between flex-grow pl-12 p-1 overflow-x-scroll'>
          <span className="text-gray-600">{ data }</span>
          <SecondaryButton icon={icon} onClick={buttonOnClick} text={buttonText} className='mr-3'/>
        </div>
        }
      </>}
      {override &&
      <div className='flex justify-between flex-grow pl-12 p-1'>
        { children }
      </div>
      }
    </div>
  )
}

export default FieldWithEdit
